import _ from "lodash";
import { store } from "@Store";

export const getBackendUrl = () => {
  const state = store && store.getState();
  if (!_.get(state, "backendUrl") && !process.env.REACT_APP_CUBE_BACKEND) {
    return `${window.location.origin}/api-server`;
  }
  return _.get(state, "backendUrl") || process.env.REACT_APP_CUBE_BACKEND;
};

export const getImageUrl = () => {
  const state = store && store.getState();
  if (!_.get(state, "imageUrl") && !process.env.REACT_APP_IMAGES_PUBLIC_URL) {
    return `${window.location.origin}/assets/images`;
  }
  return _.get(state, "imageUrl") || process.env.REACT_APP_IMAGES_PUBLIC_URL;
};

export const getStreamServerUrl = () => {
  const state = store && store.getState();
  if (!_.get(state, "streamServerUrl") && !process.env.REACT_APP_STREAMING_SERVER_PATH) {
    return `wss://${window.location.host}/stream-server`;
  }
  return _.get(state, "streamServerUrl") || process.env.REACT_APP_STREAMING_SERVER_PATH;
};

export const shouldShowSupport = (portalData?: { showSupport?: boolean } | null): boolean =>
  Boolean(portalData?.showSupport);

export const getSupportContactHref = (): string => `mailto:${process.env.REACT_APP_CUBE_SUPPORT_EMAIL}`;
